import { INotificationTableRow } from '@/feed/Feed.interface'

function FeedPostBackTable({
  rows,
  tableHeading,
  className
}: {
  rows: INotificationTableRow[]
  tableHeading?: string
  className?: string
}) {
  return (
    <table className={className}>
      {tableHeading && (
        <caption className="text-left font-semibold">{tableHeading}</caption>
      )}

      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <td>{row.label}</td>
            <td>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default FeedPostBackTable
